import { customerRequestContants } from '../../_constants';
import { customerRequestServices } from '../../_services';
import { alertActions, userActions, } from '../index';
import { confirmPromptActions } from '../confirmPromptActions';

export const customerRequestActions = {
    fTSCompanyName,
    loadRequested,
    getRequestedId,
    createRequested,
    updateRequestedId,
    updateToArchive,
    updateStatus,
    deleteRequest,

    resetCustomerRequest,
}
function resetCustomerRequest() { return { type: customerRequestContants.RESET } }

function requestFetching() { return { type: customerRequestContants.REQUEST_FETCHING } }
function requestFetched() { return { type: customerRequestContants.REQUEST_FETCHED } }

function requestSubmitting() { return { type: customerRequestContants.REQUEST_SUBMITTING } }
function requestSubmitted() { return { type: customerRequestContants.REQUEST_SUBMITTED } }

function fTSCompanyName(company) {
    return dispatch => {
        dispatch(requestFetching());
        customerRequestServices.fTSCompanyName(company)
            .then(
                companySearched => {
                    dispatch(requestFetched());
                    dispatch(success(companySearched));
                },
                error => {
                    dispatch(requestFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(companySearched) { return { type: customerRequestContants.SEARCH_COMPANY, companySearched } }
}
function loadRequested(data) {
    return dispatch => {
        dispatch(requestFetching());
        dispatch(userActions.allowLeavePage());
        customerRequestServices.loadRequested(data)
            .then(
                loadCompanyRequest => {
                    dispatch(requestFetched());
                    dispatch(success(loadCompanyRequest));
                },
                error => {
                    dispatch(requestFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(loadCompanyRequest) { return { type: customerRequestContants.LOAD_COMPANY_REQUEST, loadCompanyRequest } }
}
function getRequestedId(id) {
    return dispatch => {
        dispatch(requestFetching());
        dispatch(userActions.allowLeavePage());
        customerRequestServices.getRequestedId(id)
            .then(
                getRequestById => {
                    dispatch(requestFetched());
                    dispatch(success(getRequestById));
                },
                error => {
                    dispatch(requestFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(getRequestById) { return { type: customerRequestContants.GET_COMPANY_REQUEST_BY_ID, getRequestById } }
}
function createRequested(payload) {
    return dispatch => {
        dispatch(requestSubmitting());
        dispatch(userActions.notallowLeavePage());
        customerRequestServices.createRequested(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(requestSubmitted());
                    dispatch(alertActions.success('Successfully Created Request Customer'));
                    if(payload.status === 'For Approval'){
                        window.location.href = `/customerRequest/forApproval`;
                    }
                    else{
                        window.location.href = `/customerRequest/draft`;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(requestSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function updateRequestedId(payload, id) {
    return dispatch => {
        dispatch(requestSubmitting());
        dispatch(userActions.notallowLeavePage());
        customerRequestServices.updateRequestedId(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(requestSubmitted());
                    dispatch(alertActions.success(success.message));
                    if(payload.status === 'For Approval'){
                        window.location.href = `/customerRequest/forApproval`;
                    }
                    else{
                        window.location.href = `/customerRequest/draft`;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(requestSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function updateToArchive(payload) {
    return dispatch => {
        dispatch(requestSubmitting());
        dispatch(userActions.notallowLeavePage());
        customerRequestServices.updateToArchive(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(requestSubmitted());
                    dispatch(alertActions.success(success.message));
                    window.location.href = `/customerRequest/archive`;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(requestSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function updateStatus(payload, link) {
    return dispatch => {
        dispatch(requestSubmitting());
        dispatch(userActions.notallowLeavePage());
        customerRequestServices.updateStatus(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(requestSubmitted());
                    dispatch(alertActions.success(success.message));
                    if (link) {
                        window.location.href = link;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(requestSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function deleteRequest(payload, userId, isApprover, status, skip, take, isArchive) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        customerRequestServices.deleteRequest(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    let load = {
                      userId: userId,
                      isApprover: isApprover,
                      status: status,
                      search: "",
                      skip: skip,
                      take: take,
                      isArchive: isArchive
                    };
                    dispatch(loadRequested(load));
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Customer Request Deleted Successfully'));
                    window.location.href = `/customerRequest/draft`;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}